// Mode manager sur une CAISSE (owner 2026-09-29) : quand un manager de la
// boutique est reconnu (par son code), la caisse travaille sans limite
// pendant quelques minutes — pages et actions réservées ouvertes, et chaque
// appel au serveur porte sa preuve (en-tête X-Kipara-Actor, identityGate).
// La preuve du serveur vit 5 min : le mode s'arrête un peu avant, tout seul,
// ou quand on touche « Terminer ». Rien ne dépend d'autre module ici (évite
// les imports circulaires avec authService / identityGate).
const KEY = 'kp_manager_session';
const EVENT = 'kipara:manager-session';
export const MANAGER_SESSION_MS = 4.5 * 60 * 1000;

let session = null;
let timer = null;

const now = () => Date.now();
const emit = () => { try { window.dispatchEvent(new CustomEvent(EVENT)); } catch (_) { /* SSR / tests */ } };

function persist() {
  try {
    if (session) sessionStorage.setItem(KEY, JSON.stringify(session));
    else sessionStorage.removeItem(KEY);
  } catch (_) { /* private mode */ }
}

function arm() {
  if (timer) clearTimeout(timer);
  timer = null;
  if (session) timer = setTimeout(() => endManagerSession(), Math.max(0, session.until - now()));
}

// Relu après un rechargement de la page (même onglet) tant qu'il est valable.
try {
  const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  if (saved && saved.until > now() && saved.who && saved.who.id) { session = saved; arm(); }
} catch (_) { /* ignore */ }

export function getManagerSession() {
  if (session && session.until <= now()) { session = null; persist(); }
  return session;
}

export function startManagerSession(who) {
  session = { who, until: now() + MANAGER_SESSION_MS };
  persist();
  arm();
  emit();
  return session;
}

export function endManagerSession() {
  if (!session) return;
  session = null;
  persist();
  arm();
  emit();
}

export function onManagerSessionChange(fn) {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}
